import { Col, Image, Row } from "antd";
import { ReactNode } from "react";
import { Logo, Text, Container, MenuToggle } from "./style";
import { GiRailRoad } from "react-icons/gi";
import { AiOutlineMenu } from "react-icons/ai";
import { useAuth } from "../../context/AuthContext";

import TcsmgLogo from "../../assets/tcsmg/logo-tcs-01.png";

interface IHeader {
  children?: ReactNode;
  title?: string;
  showIcon?: boolean;
  showMenuToggle?: boolean;
  onToggleSidebar?: () => void;
}
const Header: React.FC<IHeader> = ({
  children,
  title,
  showIcon,
  showMenuToggle,
  onToggleSidebar,
}) => {
  const { authenticated } = useAuth();

  return (
    <Container>
      <Row style={{ width: "100%", alignItems: "center", flexWrap: "nowrap" }}>
        {showMenuToggle && (
          <MenuToggle
            type="button"
            aria-label="Abrir menu"
            onClick={onToggleSidebar}
          >
            <AiOutlineMenu size={20} color="#fff" />
          </MenuToggle>
        )}
        <Col className="gutter-row" sm={24}>
          {!authenticated && (
            <Logo>
              <Image src={TcsmgLogo} height={"70px"} preview={false} />
            </Logo>
          )}

          {showIcon && (
            <Col className="gutter-row" sm={1}>
              <GiRailRoad size={26} color="white" />
            </Col>
          )}
          {title && (
            <>
              <Text style={{ fontSize: 24 }}>{title}</Text>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
};
export default Header;
